<template>
  <div class="m-0 t-0 border-bottom border-bottom-dark">
    <b-navbar
      type="dark"
      variant="dark"
      class="bg-aegis-dk"
    >
      <b-navbar-nav>
        <b-nav-item @click="toggleSidebar()">
          <i
            class="fas tw-text-2xl"
            :class="{'fa-bars': !sidebar, 'fa-angle-double-left': sidebar, }"
          ></i>
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <span v-if="last_run" style="display: flex; align-items: center; color: white; font-size: 14px; font-weight: lighter; margin-right: 50px;">
          <!-- decided not to display next_run -->
          <div>
            Last Updated:&nbsp;&nbsp;&nbsp;{{ last_run }}
          </div>
        </span>
        <b-link v-if="user.is_superuser" :to="{name: 'etl-runs'}" title="ETL Run Metrics"><i class="fa fa-tachometer-alt float-right icon-link" style="margin-right: 20px;"></i></b-link>
        <b-link :to="{name: 'feature-request'}" title="Portal feature requests"><i class="fa fa-lightbulb float-right icon-link"></i></b-link>
        <b-nav-item-dropdown right :no-caret="true">
          <template slot="button-content">
            <i class="fas fa-user-circle tw-text-2xl"></i>
          </template>
          <b-dropdown-item :to="{name: 'user'}">Profile</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import { mapActions, mapState } from "vuex";
// import * as moment from 'moment';
import moment from 'moment-timezone';

export default {
  data() {
    return {
      drawer: true,
      last_run: null,
      next_run: null,
      study_name: 'kenya'
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState(["sidebar"])
  },
  mounted: function() {
    let that = this;
    let study = "kenya"
    if(this.STUDY=="srilanka"){
      study = "srilanka"
    } else if (this.STUDY=="eavetubes" || this.STUDY=="uganda") {
      study = this.STUDY;
      this.study_name = this.STUDY;
    }
    HTTP.get(`/${study}/etl/get_status`).then(response => {
      var timestamp_in_tz = moment(response.data.last_run_ended).tz(moment.tz.guess());
      that.last_run = timestamp_in_tz.format("MMM DD, YYYY @ HH:mm");
    }).catch(() => {});

    // decided not to display next_run
    // var current_time = moment();
    // var next_run = current_time;
    // if(current_time.minute() < 30){
    //   next_run.minute(30);
    //   next_run.second(0);
    // }
    // else{
    //   next_run.minute(0);
    //   next_run.second(0);
    //   next_run.add(1, 'hours');
    // }
    // that.next_run = next_run.format("MMM DD, YYYY @ HH:mm");

  },
  methods: {
    ...mapActions([
      "setBaseComponent",
      "clearAuthorizationToken",
      "toggleSidebar"
    ]),
    ...mapActions("user", ["setUser"]),
    goTo(route) {
      this.$router.push(route);
    },
    toggle: function() {
      this.drawer = !this.drawer;
    },
    logout: function() {
      this.clearAuthorizationToken();
      this.setUser({});

      this.$notify({
        text: "You have been logged out",
        duration: 10000,
        type: "warn"
      });

      this.$router.push({
        name: "home"
      });
    }
  }
};
</script>

<style>
  .sidebar-space.fixed-top {
    left: 190px;
  }
  .no-sidebar-space.fixed-top {
    left: 0;
  }
  .icon-link {
      font-size: large;
      color: rgba(255, 255, 255, 0.5);
      position: relative;
      top: 10px;
      left: -20px;
  }
  .icon-link:hover{
    color: #e2e8f0;
  }
</style>
